const urlToId = (url = '') => {
  const idRegExp = new RegExp('/[a-z0-9]+/[_a-z]+/([0-9]+)');

  const results = idRegExp.exec(url);
  if (results && results.length >= 2) return results[1];

  return '';
};

const getAllQueryParamsFromQueryString = (queryString) => {
  const values = queryString.slice(queryString.indexOf('?') + 1).split('&');
  return values.reduce((acc, v) => {
    const [key, value] = v.split('=');
    acc[key] = value;

    return acc;
  }, {});
};

const serialize = (obj) => {
  const str = [];
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      str.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[prop]));
    }
  }
  return str.join('&');
};

export { urlToId, getAllQueryParamsFromQueryString, serialize };
export default undefined;

// dummy
